import { useRef, useState } from "react";

const UploadRecordingButton = ({ ...props }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState("");

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (!file) return;
    console.log("File dropped:", file);

    const isValid =
      file.type.includes("mp3") ||
      file.type.includes("wav") ||
      file.name.endsWith(".mp3") ||
      file.name.endsWith(".wav");

    if (!isValid) {
      setError("Please upload a valid MP3 or WAV file.");
      return;
    } else {
      setError("");
    }

    // Build a synthetic ChangeEvent React can handle
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);

    const syntheticEvent = {
      target: { files: dataTransfer.files },
    } as unknown as React.ChangeEvent<HTMLInputElement>;

    props.handleRecording(syntheticEvent);
    setIsDragging(false);
  };
  
  return (
    <div className="upload-recording-wrapper">
      <div
        className={`upload-recording-zone ${isDragging ? "dragging" : ""} ${props.hasFile ? "has-file" : ""}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => inputRef.current?.click()}
      >
        <div className="upload-icon-circle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
        </div>

          <div className="upload-recording-text">
            {error ? (
              <span className="error-text">{error}</span>
            ) : (
              <span className="primary-text">
                {props.hasFile ? "Replace Recording" : "Upload Recording"}
              </span>
            )}
            <span className="secondary-text">MP3 or WAV · drag & drop or click</span>
          </div>

          <input
            ref={inputRef}
            type="file"
            accept=".mp3,.wav,audio/mpeg,audio/wav"
            onChange={props.handleRecording}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      </div>
  );
};

export default UploadRecordingButton;
function addAlert(arg0: string, arg1: string) {
  throw new Error("Function not implemented.");
}

